import { Link } from "react-router-dom";
import { Home, Mail, MapPin, Phone } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-[#1C2A1F] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <Home className="w-6 h-6 text-[#D88A2B]" />
              <span className="text-xl font-bold">Kokan Homestays</span>
            </div>
            <p className="text-[#9CA88F] text-sm leading-relaxed mb-5 max-w-[260px]">
              Discover authentic homestays across the Konkan coast for unforgettable experiences.
            </p>
            <div className="flex items-center gap-2 text-sm text-[#9CA88F]">
              <Mail className="w-4 h-4 text-[#D88A2B] flex-shrink-0" />
              <span>info@kokanhomestays.com</span>
            </div>
          </div>

          {/* Destinations */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-[#D88A2B] mb-4">
              Destinations
            </h4>
            <ul className="space-y-2.5">
              {["Alibaug", "Dapoli", "Ganpatipule", "Malvan", "Tarkarli", "Ratnagiri"].map((d) => (
                <li key={d}>
                  <Link to={`/search/homestays-in-${d.toLowerCase()}`} className="text-sm text-[#9CA88F] hover:text-white transition-colors">
                    {d}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-[#D88A2B] mb-4">
              Company
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-[#9CA88F] hover:text-white transition-colors" data-testid="footer-home">Home</Link></li>
              <li><Link to="/listings" className="text-sm text-[#9CA88F] hover:text-white transition-colors" data-testid="footer-listings">All Homestays</Link></li>
              <li><Link to="/places" className="text-sm text-[#9CA88F] hover:text-white transition-colors" data-testid="footer-places">Explore Places</Link></li>
              <li><Link to="/blog" className="text-sm text-[#9CA88F] hover:text-white transition-colors" data-testid="footer-blog">Blog</Link></li>
              <li><Link to="/list-your-homestay" className="text-sm text-[#9CA88F] hover:text-white transition-colors" data-testid="footer-list-homestay">List Your Homestay</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-[#D88A2B] mb-4">
              Support
            </h4>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-[#9CA88F]">Help Centre</span></li>
              <li><span className="text-sm text-[#9CA88F]">Privacy Policy</span></li>
              <li><span className="text-sm text-[#9CA88F]">Terms of Service</span></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[#6B7A5E]">
            &copy; {new Date().getFullYear()} Kokan Homestays. All rights reserved.
          </p>
          <p className="text-xs text-[#6B7A5E]">
            Made with care for the Konkan coast
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
